import React, {useEffect} from 'react';
import {Overlay as OverlayStyled} from './Overlay-styles';

type Props = {
  isVisible: boolean;
  onClick: () => void;
};

const Overlay = ({isVisible, onClick}: Props) => {
  useEffect(() => {
    // if is visible, apply blur effect to the body
    if (isVisible) {
      document.body.style.overflow = 'hidden';
      document.body.style.backgroundColor = 'rgba(17, 24, 39, 0.14)';
      document.body.style.backdropFilter = 'blur(3px)';
      document.body.style.opacity = '1';
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflow = '';
      document.body.style.backgroundColor = '';
      document.body.style.backdropFilter = '';
      document.body.style.zIndex = '';
      document.body.style.opacity = '';
    }
    return () => {
      // Clean up styles when the component is unmounted or isVisible changes
      document.body.style.overflow = '';
      document.body.style.backgroundColor = '';
      document.body.style.backdropFilter = '';
      document.body.style.zIndex = '';
      document.body.style.opacity = '';
    };
  }, [isVisible]);
  return <OverlayStyled isVisible={isVisible} onClick={onClick} />;
};

export default Overlay;
